'use strict';
module.exports = function microsoftTeamsLegacyContextAdapter(v2Context) {
	const result = {};
	result.channelType = v2Context?.channel?.membershipType;
	result.hostTeamGroupId = v2Context?.channel?.ownerGroupId;
	result.channelId = v2Context?.channel?.id;
	result.groupId = v2Context?.team?.groupId;
	result.tid = v2Context?.user?.tenant?.id;
	result.loginHint = v2Context?.user?.loginHint;
	result.entityId = v2Context?.page?.id;
	return result;
};
